<div *ngIf="actual" [ngClass]="{'exceeded': amountPair.actual > amountPair.anticipated }"
     class="anticipated-single-amount">
    <span class="anticipated-text">Anticipated: </span>
    <span class="total-text">{{ amountPrefix }}{{ amountPair.anticipated }}{{ amountSuffix }}</span>
</div>
<div class="single-amount-div">
    {{ amountPrefix }}
    <input (change)="onChangeCallback(amountPair)"
           (focusin)="onFocus()"
           (keyup)="onChangeCallback(amountPair)"
           [(ngModel)]="boundAmount"
           [disabled]="disabled"
           [min]="min"
           [ngModelOptions]="{standalone: true}"
           [placeholder]="placeholder"
           [step]="step"
           class="single-amount-input"
           type="number"/>
    {{ amountSuffix }}
</div>
